"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useInjectorHook = void 0;
function useInjectorHook(token, injector) {
    return [injector.get(token), injector];
}
exports.useInjectorHook = useInjectorHook;
//# sourceMappingURL=use-injector-hook.js.map